// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071535/js/" + chunkId + "." + {"44":"d1778e97","225":"60b1f68d","481":"bd5bfe9a","486":"a0a9cd1a","770":"f56e2925"}[chunkId] + ".0.004723700053326008.chunk.js";
};